<template>
  <div class="subView">
    <div class="subView_list">
      <div class="subView_item">
        <div class="title"><span v-if="navList.length>0">{{navList[0].columnText}}</span><span style="border: 2px solid #CCCBDB;font-size: 18px;position: relative;margin-left: 20px"></span>
          <span class="text" style="margin-left: 10px" v-if="navList.length>0">
                    {{navList[0].list[1].columnText}}</span>
        </div>
        <div class="btnBox">
          <el-button class="btn" @click="goabout()">免费咨询</el-button>
        </div>
      </div>
      <div class="box-right">
        <el-row :gutter="24">
          <el-col class="subView_top" v-for="(item,index) in List" :key="index" :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
            <el-card style="margin-bottom: 30px;height: 430px">
              <div  class="card">
                <img :src="item.img" class="image">
                <div class="text" style="">
                  <span class="title">{{ item.title }}</span>
                  <div class="content">
                    <span>{{ item.content }}</span>
                  </div>
                </div>
                <div class="btnBox">
                  <el-button class="btn"  @click="goToUrl(item.href)">购买</el-button>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>

      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import saasNav from '../mtevidence/saas-nav.vue'
export default {
  name: "mtevidence",
  components:{saasNav},
  data(){
    return{
      navList:{},
      List:[
        {title:"震动传感器",content:"震动传感器将半埋于地下，可通过运动目标产生的地震动信号识别人、车等多种目标，识别人员行走、挖掘或车辆通过等事件，设备自带无线通信与定位模块，可将探测信息通过网关实时传回后端。",href:"https://ic-item.jd.com/100171565018.html",img:require ("../../assets/purchaseImg/img.png")},
        {title:"图像传感器",content:"用于对布设地域进行视频监控并对视野内目标类别、行为进行识别,设备自带无线通信、定位及电源模块，可通过网关将探测信息实时传回后端。分全彩、红外两种类型 ，昼夜工作。",href:"https://ic-item.jd.com/100138413895.html",img:require ("../../assets/purchaseImg/img_1.png")},
        {title:"声音传感器",content:"采用拾音咪头对布设地域进行监控并对视野内目标类别、行为进行识别，在室外环境下，半径在30米范围内，方位角定位误差不高于10度。",href:"https://ic-item.jd.com/100171936056.html",img:require ("../../assets/purchaseImg/img_2.png")},
        {title:"红外传感器",content:"采用被动红外摄像头对布设地域进行监控并对视野内目标类别、行为进行识别，设备自带无线通信、定位及电源模块，可通过网关将探测信息实时传回后端。",href:"https://ic-item.jd.com/100132077600.html",img:require ("../../assets/purchaseImg/img_3.png")},
        {title:"地磁传感器",content:"采地磁传感器埋设于地下，通过探测周边磁场变化识别周边金属物体的运动情况，设备自带无线通信、定位及电源模块，可通过网关将识别结果实时传回后端。",href:"https://ic-item.jd.com/100111842207.html",img:require ("../../assets/purchaseImg/img_4.png")},
        {title:"自组网网关",content:"采地网关将无线自组网协议数据转换为USB协议数据，可将覆盖地域内传感器信息汇聚至监控终端。",href:"https://ic-item.jd.com/100166108868.html",img:require ("../../assets/purchaseImg/img_5.png")},
      ],
    }
  },
  created(){
    this.getDataList()
  },
  mounted() {
    document.documentElement.scrollTop = 0;
  },
  methods:{
    goToUrl(href) {
      window.open(href);
    },
    goabout(){
      this.$router.push({
        name: 'about_mobile'
      })
    },
    getDataList() {
      if(this.$route.query.text){
        axios.post("https://article.chenhaninfo.com/publish-article/sys/column/columnList", {
        }).then(({data}) => {
          if (data && data.code === 0) {
            for (let item of data.list) {
              if (item.columnText == '群智协同产品') {
                this.navList = item.list
              }
            }
          }
        }).catch(function (error) {
          console.log(error);
        })
      }

    },
  }
}
</script>

<style scoped lang="scss">
.subView {
  margin-top: 78px;
  background-color: #fff;
  width: 100%;
  .subView_list {
    .subView_item {
      background-image: url("../../assets/mtevidence/beijing.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 100%;
      height: 200px;
      text-align: center;

      .title {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #282B31;
        padding-top: 50px;

        .text {
          font-size: 20px;
          font-weight: 500;
          color: #2D3036;
        }
      }

      .btnBox {
        margin-top: 32px;
      }

      .btn {
        width: 125px;
        height: 39px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        // line-height: 16px;
        background: #0069FD;
        border-radius: 20px;
      }
    }

    .box-right{
      width: 90%;
      min-height: 220px;
      padding: 30px 0;
      margin: 0 auto;
    }
    .subView_top{
      .card{
        margin: 0 auto;
        .image{
          width: 250px;
          height: 200px;
          display: block;
          margin: 14px auto 0 auto;
        }
        .text{
          padding: 14px 40px;
          margin: 0 auto;
          height: 100px;
          .title{
            margin-top: 10px;
          }
          .content{
            margin-top: 5px;
            overflow:hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 4;
            display: -webkit-box;
            -webkit-box-orient: vertical;
          }
        }
        .btnBox {
          margin-top: 10px;
        }
        .btn {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          // line-height: 16px;
          background: #0069FD;
          border-radius: 20px;
          margin-right: 40px;
          float: right;
        }
      }
    }


  }
}
</style>
